import { useTranslation } from 'react-i18next';
import { TriangleAlert } from 'lucide-react';
import { useStatus } from '../lib/useStatus';

/**
 * Bannière plein écran quand le budget IA est bientôt épuisé. C'est une alerte
 * système (pas un réglage) : elle reste visible même sans ouvrir la roue dentée,
 * qui elle affiche le détail du solde (voir GearMenu).
 */
export function BudgetAlertBanner() {
  const { t } = useTranslation();
  const status = useStatus();
  if (!status?.budget.low) return null;
  return (
    <div
      className="fixed inset-x-0 top-0 z-10 flex items-center justify-center gap-1.5 bg-red-500/90 py-1 text-center text-sm text-white"
      role="alert"
    >
      <TriangleAlert className="h-4 w-4" /> {t('status.low')}
    </div>
  );
}
